export enum RequestStatusType {
    error = 'error',
    success = 'success',
    loading = 'loading',
}
